var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXLogoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121 121"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 0C27.09 0 0 27.09 0 60.5S27.09 121 60.5 121 121 93.91 121 60.5 93.91 0 60.5 0zm10.21 86.29L56.95 66.27 39.72 86.29h-4.45l19.7-22.9-19.7-28.67H50.3l13.03 18.96 16.31-18.96h4.45L65.3 56.56 85.73 86.3H70.7z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.98 56.4L48.16 38.06h-6.84l15.89 22.72 1.99 2.86 13.6 19.45h6.84L62.98 59.26l-2-2.86z"
  })));
}

export default __webpack_public_path__ + "3cc6508cb6f6d8b3d40dfe1643f4a634.svg";
export { SvgXLogoCircle as ReactComponent };